<template>
    <!--三个按钮-->
    <div class="row san">
        <div class="col fang"><router-link to="avoidFraud" type="button" class="btn btn-success">防骗指南</router-link></div>
        <div  class="col zhang"><router-link to="EarnbySharing" type="button" class="btn btn-success coo">分享赚钱</router-link></div>
    </div>
    <!--三个按钮-->
</template>

<script>
    export default {
        name: "TwoTuttons2"
    }
</script>

<style scoped>
    .btn-success{
        background-color: #18b371 !important;
        border: none !important;
    }
    .coo{
        background-color:#ff6d5f !important;
    }

    .btn{
        line-height: 1rem;
        font-size: 0.9rem!important;
    }
    /*回家的路三个按钮与下边板块的边距*/
    .san{
        padding-bottom:10px;
    }
    .zhang{
        text-align: left;
        /*padding: 0 !important;*/
    }
    .fang{
        text-align: right;
        /*padding-right: 0 !important;*/
    }

</style>